import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import InputDataVue from '../views/InputDataView.vue'
import ExplainListVue from '../views/ExplainListView.vue'
import ExplainVue from '../views/ExplainView.vue'
import DebugVue from '@/views/DebugView.vue'
import i18n from '@/i18n'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomeView,
  },
  {
    path: '/input',
    name: 'InputData',
    component: InputDataVue,
  },
  {
    path: '/explain',
    name: 'ExplainList',
    component: ExplainListVue,
    // Function mode
    props: (route) => route.params,
  },
  {
    path: '/explain/:palaceId/:star',
    name: 'Explain',
    component: ExplainVue,
    props: (route) => route.params,
  },
  {
    path: '/debug',
    name: 'Debug',
    component: DebugVue,
    props: (route) => route.params,
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

router.beforeEach(() => {
  // console.log(i18n.global.t('page.title'))
  document.title = i18n.global.t('page.title')
})

export default router
